module.exports = __webpack_public_path__ + "img/agent_1.77ae2536.png";